export default __webpack_public_path__ + "locales/de/DeleteThirdPartyDialog.json?hash=ad28c5a18d8a997b0bad114474d34369";